// extracted by mini-css-extract-plugin
export default {"container":"SearchInput__container___2Lexg"};